module.exports = __webpack_public_path__ + "static/media/edit_ticket-office.c6406ed4.png";